import { useState, useEffect } from 'react';
import { parseDateString } from '../utils/stringUtils';

const useNews = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await fetch(`${process.env.PUBLIC_URL}/resources/data/news.json`);
        
        if (!response.ok) {
          throw new Error(`Error fetching news: ${response.status}`);
        }
        
        const data = await response.json();
        
        // Sort news by date (newest first), now supporting time
        const sortedNews = [...(data.news || [])].sort((a, b) => {
          const dateA = parseDateString(a.date);
          const dateB = parseDateString(b.date);
          return dateB - dateA; // Descending order (newest first)
        });
        
        setNews(sortedNews);
        setLoading(false);
      } catch (err) {
        console.error("Failed to load news:", err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  // Tìm bài viết theo slug
  const getNewsBySlug = (slug) => {
    return news.find(item => item.slug === slug) || null;
  };

  // Tìm bài viết theo ID
  const getNewsById = (id) => {
    return news.find(item => item.id === Number(id)) || null;
  };

  return {
    news,
    loading,
    error,
    getNewsBySlug,
    getNewsById
  };
};

export default useNews;
